import { AcademicCapIcon, BookOpenIcon } from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

// Member-facing Learning Center. Visible to all authenticated users — no
// permission gate (the WI-04/WI-05 learner endpoints are open to any
// authenticated user).
const navigation: NavigationItem[] = [
  {
    name: "Courses",
    href: "/hub/learning-center/courses",
    icon: AcademicCapIcon,
    current: false,
    internalName: "learning-center-courses",
  },
  {
    name: "My Courses",
    href: "/hub/learning-center/my-courses",
    icon: BookOpenIcon,
    current: false,
    internalName: "learning-center-my-courses",
  },
];

const learningCenterConfig = {
  sectionName: "learning-center",
  defaultRoute: "/hub/learning-center/courses",
  navigation,
};

export default learningCenterConfig;
